import React, { Component } from 'react';
import './css/main.css';
import { Helmet } from "react-helmet";

// Default setup
import Navigation from './layout/navigation/Navigation';
import Footer from './layout/footer/Footer';
import ProjectInfo from './layout/portfolio/ProjectInfo';
import GalleryGridFront from './layout/portfolio/GalleryGridFront';
import BriefIcon from './layout/hero/BriefIcon';
import WarpLarge from './layout/warp/WarpLarge';
import NextUp from './layout/warp/NextUp';

import Paragraph from './layout/Paragraph';
import ProcessThreeSteps from './layout/Process';

import ImageGridx1 from './layout/portfolio/ImageGridx1';
import ImageGridx2 from './layout/portfolio/ImageGridx2';
import ImageGridx3 from './layout/portfolio/ImageGridx3';

import GalleryGridx1 from './layout/portfolio/GalleryGridx1';
import GalleryGridx2 from './layout/portfolio/GalleryGridx2';
import VideoMockup from './layout/portfolio/VideoMockup';
import PenIcon from './asset/PenIcon';

import Front from './img/performanceLeader/performanceLeader_feature@2x.png';
import KeyScreen from './img/performanceLeader/PL_optimisation@2x.png';

import PL_understanding from './img/performanceLeader/PL_understanding@2x.png';
import PL_flow from './img/performanceLeader/MobileFeedbackFlow@2x.jpg'
import PL_Logo from './img/performanceLeader/pl_logo.svg';

import PL_Template1 from './img/performanceLeader/PL_Templates@2x.jpg';
import PL_Template2 from './img/performanceLeader/PL_Templates2@2x.jpg';

import PL_ScreenSample1 from './img/performanceLeader/PLScreenshot_Dashboard@2x.png';
import PL_ScreenSample2 from './img/performanceLeader/PLScreenshot_Debrief@2x.png';
import PL_ScreenSample3 from './img/performanceLeader/PLScreenshot_Objectives@2x.png';
import PL_optimisation from './img/performanceLeader/PL_optimisation@2x.jpg';
import PL_Card from './img/performanceLeader/PL_Templates_card@2x.jpg';
import PL_Form from './img/performanceLeader/PL_Templates_form@2x.jpg';
import PL_Type from './img/performanceLeader/PL_ReviewTypes@2x.png';

import PL_Donation from './img/performanceLeader/PL_Donation@2x.png';
import PL_Fastfeedback from './img/performanceLeader/PL_Fastfeedback@2x.png';
import PL_Mobile from './img/performanceLeader/PL_Mobile@2x.jpg';


// Summary
const companyInfo = {
  title: "Flexible, continous and agile feedback to manage talent",
  name: "Performance Leader",
  themeColor: "#26CD9E",
  themeTextColor: "white",
  frontImage: Front,
  role: "Product design consultant",
  fields: "Product design (UX/UI)",
  time: "AUG 2018 – Present (Consultant)",
  paragraph:"There was a time I had to take a hiatus from work to due to a health issue back in late 2018. During this time, the founder from Sportsmate contacted me for a casual design role to create a new SAAS tool for performance reviews. From then, it has been my on and off side hustle for 2 years."
}


const list = ['Created core experiences - Project review, Quick feedback, Donation flow.', 'Designed customisable modules to build KPIs, personal goals, and project reviews.', 'Improved the usability over time by mitigating common confusions and design optimisations.', 'Created design system for mobile and web.', 'Directed the look and feel of the online platform.']

const aboutPL = {
  summary: "ABOUT THE COMPANY",
  image: KeyScreen,
  title: "Who are Performance Leader?",
  paragraph: "Founded by a former lawyer with HR expertise and a software engineer with a passion for digital products, Performance Leader is a company that offers highly customisable talent management service for professional organisations. The service has been helping companies in more than 30 countries to support fast, engaging, and continuous feedback.",
  textColor: "#ffffff",
  themeColor: "#198FAA",
}

const PLSolutionApproach = {
  summary:"THE APPROACH",
  heading:"Every team is different, every manager has their own style to manage people. What if they can create a format that works best for their team?",
  paragraph:"Our solution to this problem was to help managers with a mind of “Let them create anything that works”. Instead of following the common step-by-step process, we were focusing on the ease of tailoring them. \n\nAs a product designer, I’ve worked on various modular components, from a survey for a team to simple 5 star ratings. This helps clients freely create formal and informal feedback templates.",
  image_1: PL_Template2,
  image_1_caption:"You can build new feedback in anyway you want. The managers can follow the usual review framework, or create something totally personal. It's up to the context!",
  image_2: PL_Template1,
  image_2_caption: "Some components were designed for casual and informal communication. We aimed for enabling smaller but frequent appreciations in the team."
}


const PLDesignIteration = {
  summary: "Design iterations",
  heading: "When the product is highly flexible, it's harder to predict how the design solutions will turn out. I improved the design overtime after seeing how real people use it.",
  paragraph: "The flexible aspect of Performance Leader wasn't always on the designer's side. Due to the atypical HR process in different companies, it was hard to predict how the experience design will work in the real world. For instance, the design flow I’m designing may or may not work for some organisations.\n\nIn order to overcome the unpredictable nature, I took an approach of 'Fake it till you make it' – Updating the design retrospectively based on feedback and usage while being bold with releasing the first version with the best design practices in mind.",
  paragraph_2: "The important lesson I learned was taking a balance between consistency and individualisation. Creating a design system and reusing components can speed up the production, but it can also make everything look similar.\n\nThere are still lots of things to do to improve the design in both web and app experiences. Currently, I'm exploring to find a perfect balance between those two, with an interchangeable design flow across the web and app.",
  caption: "The before & after. During the first release, I aimed to create a versatile card UI to be used in many screens. The second version is focusing on improving usability with clearly differences between each state of the review."
}

const PLModuleProcess = {
  summary: "the challenge",
  summary_2: "Then, why do they desire for a flexible tool? ",
  heading: "Why have many organisations created their own method to manage talent? Understanding the role of performance review was the first step.",
  heading_2: "Every team is different, every manager has their own style to manage people. What if they can create a format that works best for their team?",
  paragraph: "Managing talent is arguably the most important goal of any organisation. Many firms define a structured measurement to use in remuneration reviews for their employees. \n\nIn the world of talent management, it's not uncommon to see companies still rely on the same measures they had defined more than a decade ago. To better understand the purpose of talent management was the first challenge I had with Performance Leader.",
  paragraph_2: "The problem of many existing HR platforms was that they are too rigid to tailor for each company. As a result, many firms reluctantly have to break their existing styles to digitise the HR process. Even worse, the leader in the team has to sacrifice their productivity to overcome the limitation of the tool.",
  paragraph_3: "Performance Leader's goal is to let people leaders create any modules in any style – so that the organizations can manage the talent with continuity.",
}

const PLFastFeedback = {
  summary: "Fast Feedback",
  heading: "Have more chances to look back on your performance, more than twice a year.",
  paragraph: "Most companies conduct performance review twice a year. Six months is a long time to look back to remember what's happened. Fast feedback is designed to fill the gap. Fast feedback encourages everyone to give feedback to each other when the memory is still fresh.\n\nI've taken a modular design approach and kept on improving how to make it easy to nudge people to start giving feedback.",
  themeColor: "#E07890",
  textColor: "#ffffff",
  image_1: PL_Template1,
  image_2: PL_Card,
}


const PLMobileApp = {
  summary: "Mobile app",
  heading: "Create and receive instant feedback anywhere on your mobile phone.",
  paragraph: "Every experience is designed with mobile in mind. Although most of the admin flow is more optimised on desktop, we are on the way to implement a companion mobile app to make it easy to view and give fast feedback from your fingertips.\n\nI was responsible for creating interactive prototypes for fast review, and how we can create an interchangeable UI across the web and mobile apps.",
  themeColor: "#ffffff",
  image_1: PL_Template1,
  image_2: PL_Card
}

const PLDonationFlow = {
  summary: "Donation flow",
  heading: "Nominate a charity your company will donate to every time you finish feedback.",
  paragraph: "Last but not least, we created a little feature to encourage the company to give back to society. Every time an employee completes and submits a review, they can chip into nominating a charity for their company to donate.",
  themeColor: "#8F96ED",
  textColor: "#ffffff",
  image_1: PL_Donation,
  image_2: PL_Card
}

const metatag = {
  title: "Portfolio ✴︎ " + companyInfo.name,
  author: "Jinju Jang",
  url: "http://jinju.io/performanceLeader",
  description: companyInfo.paragraph,
  image: "http://jinju.io" + companyInfo.frontImage
}

class PortfolioPerformanceLeader extends Component {
  render() {
    return (
      <div>
        {/*Meta data*/}
        <Helmet>
          <meta charSet="utf-8"/>
          <title>{metatag.title}</title>
          <meta name="author" content={metatag.author}/>
          <meta name="description" content={metatag.description}/>

          {/*-- Google / Search Engine Tags --*/}
          <meta itemprop="name" content={metatag.title}/>
          <meta itemprop="description" content={metatag.description}/>
          <meta itemprop="image" content={metatag.image}/>

          {/*-- Open Graph / Facebook --*/}
          <meta property="og:url" content={metatag.url}/>
          <meta property="og:type" content="website"/>
          <meta property="og:title" content={metatag.title} />
          <meta property="og:description" content={metatag.description}/>
          <meta property="og:image" content={metatag.image}/>

          {/*-- Twitter --*/}
          <meta name="twitter:card" content="summary_large_image"/>
          <meta name="twitter:title" content={metatag.title}/>
          <meta name="twitter:description" content={metatag.description}/>
          <meta name="twitter:image" content={metatag.image}/>
       </Helmet>

        <Navigation />
        {/*Front page*/}
        <GalleryGridFront title={companyInfo.title} first={Front} themeColor={companyInfo.themeColor}/>
        {/*Position summary*/}
        <ProjectInfo
          title={companyInfo.name}
          role={companyInfo.role}
          fields={companyInfo.fields}
          time={companyInfo.time}
          description={companyInfo.paragraph}
          dotPoints={list}/>

        {/*----- Who are Perfomance Leader? ------*/}
        <ImageGridx1
          first={aboutPL.image}
          innerDescription={<BriefIcon summary={aboutPL.summary} titleIcon={<PenIcon color={aboutPL.textColor}/>}
          title={aboutPL.title}
          paragraph={aboutPL.paragraph} textColor={aboutPL.textColor}/>}themeColor={aboutPL.themeColor}
          showTriangle
        />

        {/*----- The problems space ------*/}
        <Paragraph
          titleText={PLModuleProcess.summary}
          heading={PLModuleProcess.heading}
          paragraph={PLModuleProcess.paragraph + "\n\n" + PLModuleProcess.paragraph_2}
        />

        <GalleryGridx1
          first={PL_understanding}
        />

        {/*----- The approach  ------*/}
        <GalleryGridx2
          first={PL_Type}
          second={PL_Form}
        />

        <Paragraph
          titleText={PLSolutionApproach.summary}
          heading={PLSolutionApproach.heading}
          paragraph={PLSolutionApproach.paragraph}
        />

        <ImageGridx1
          first={PLSolutionApproach.image_1}
          caption={PLSolutionApproach.image_1_caption}
        />
        <ImageGridx1
          first={PLSolutionApproach.image_2}
          caption={PLSolutionApproach.image_2_caption}
        />

        {/*----- Product idea  ------*/}
        <Paragraph
          titleText={PLDesignIteration.summary}
          heading={PLDesignIteration.heading}
          paragraph={PLDesignIteration.paragraph}
        />

        <GalleryGridx2
          first={PL_ScreenSample3}
          second={PL_Card}
          caption={PLDesignIteration.caption}
        />

        <Paragraph
          paragraph={PLDesignIteration.paragraph_2}
        />

        {/*----- three points ------*/}
        <ProcessThreeSteps
          heading="Highlights"
          first={PLFastFeedback.summary}
          firstDetail={PLFastFeedback.heading}
          second={PLMobileApp.summary}
          secondDetail={PLMobileApp.heading}
          third={PLDonationFlow.summary}
          thirdDetail={PLDonationFlow.heading}
          />

        {/*----- 1 ------*/}
        <ImageGridx1
          first={PL_Fastfeedback}
          innerDescription={<BriefIcon summary={PLFastFeedback.summary}
          title={PLFastFeedback.heading}
          paragraph={PLFastFeedback.paragraph} textColor={PLFastFeedback.textColor}/>}themeColor={PLFastFeedback.themeColor}
          showTriangle
        />

        {/*----- 2 ------*/}
        <ImageGridx1
          first={PL_Mobile}
          innerDescription={<BriefIcon summary={PLMobileApp.summary}
          title={PLMobileApp.heading}
          paragraph={PLMobileApp.paragraph} textColor={PLMobileApp.textColor}/>}themeColor={PLMobileApp.themeColor}
        />

        <ImageGridx1
          first={PL_flow}
        />

        {/*----- 3 ------*/}
        <ImageGridx1
          first={PLDonationFlow.image_1}
          innerDescription={<BriefIcon summary={PLDonationFlow.summary}
          title={PLDonationFlow.heading}
          paragraph={PLDonationFlow.paragraph} textColor={PLDonationFlow.textColor}/>}themeColor={PLDonationFlow.themeColor}
          showTriangle
        />

        <NextUp
          previous="Medibank"
          previousURL="/medibank"
          next="SEEK"
          nextURL="/seek"
        />
        <WarpLarge/>
        <Footer/>
      </div>
    );
  }
}

export default PortfolioPerformanceLeader;



// WEBPACK FOOTER //
// ./src/PortfolioPerformanceLeader.js